import moment, { unitOfTime } from "moment-timezone";

import { DISPLAY_FORMAT_PERIOD_DAY, TDate } from "./types";

export const formatFactory = (format: string, zone?: string) => (date?: TDate | null) => {
  if (!date) {
    return "";
  }

  const d = moment.parseZone(date);

  if (!d.isValid()) {
    return "";
  }

  return zone ? d.tz(zone).format(format) : d.format(format);
};

export const agoDate = (date?: TDate | null) => {
  if (!date) {
    return "";
  }

  const d = moment.parseZone(date);

  if (!d.isValid()) {
    return "";
  }

  return moment.parseZone(date).fromNow();
};

export const diffUntilNow = (date?: TDate | null, unit: unitOfTime.Base = "millisecond") => {
  if (!date) {
    return NaN;
  }

  const d = moment.parseZone(date);

  if (!d.isValid()) {
    return NaN;
  }

  return moment.parseZone(date).diff(moment.parseZone(), unit);
};

export const isFutureDate = (value: TDate) => {
  return moment(value).isAfter(new Date());
};

export const isPastDate = (value: TDate) => {
  return moment.parseZone(value).isBefore(new Date());
};

export const formatPeriod = (DateFormat: string) => (start: TDate, end: TDate) => {
  const startDate = moment.parseZone(start);
  const endDate = moment.parseZone(end);

  if (!startDate.isValid() || !endDate.isValid()) {
    return "";
  }

  if (startDate.year() !== endDate.year()) {
    return `${startDate.format(DateFormat)}-${endDate.format(DateFormat)}`;
  } else if (startDate.month() !== endDate.month()) {
    return `${startDate.format(DISPLAY_FORMAT_PERIOD_DAY)}-${endDate.format(DateFormat)}`;
  }

  return `${startDate.format(DISPLAY_FORMAT_PERIOD_DAY)}-${endDate.format(DateFormat)}`;
};
